// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Spin2_view_default.Spin2_progress{border-top-color:var(--spin-view-default-border-color);border-left-color:var(--spin-view-default-border-color)}", ""]);
// Exports
module.exports = exports;
